{
  "dashboard": "Дашборд",
  "courses": "Курси",
  "calendar": "Календар",
  "classes": "Класи",
  "members": "Учасники",
  "settings": "Налаштування",
  "school": {
    "switcherLabel": "Школи",
    "select": "Оберіть школу",
    "create": "Створити школу"
  },
  "tests": "Тести",
  "homework": "Домашні завдання",
  "children": "Мої діти",
  "gradebook": "Журнал",
  "attendance": "Відвідуваність",
  "myProgress": "Мій прогрес",
  "projects": "Проєкти",
  "library": "Бібліотека",
  "chats": "Чати",
  "announcements": "Оголошення",
  "notifications": "Сповіщення",
  "moderation": "Модерація",
  "apiKeys": "API-ключі",
  "billing": "Оплата"
}
